import { expectNever } from "ts-expect";
import { expectGameContext } from "../util";
import { ActionExpression, ActionExpressionValue } from "../gameData";

export function evaluateExpression(
    exp: ActionExpression,
): ActionExpressionValue {
    if (exp === null || typeof exp !== "object") {
        return exp;
    }

    if ("not" in exp) {
        return !evaluateExpression(exp.not);
    }

    if ("and" in exp) {
        return exp.and.every(evaluateExpression);
    }

    if ("or" in exp) {
        return exp.or.some(evaluateExpression);
    }

    if ("eq" in exp) {
        return evaluateExpression(exp.eq[0]) === evaluateExpression(exp.eq[1]);
    }

    if ("gt" in exp) {
        const a = evaluateExpression(exp.gt[0]);
        const b = evaluateExpression(exp.gt[1]);
        if (a === null || b === null) {
            throw new Error(
                `ActionCondition "gt" got "null" values: ${a} ${b}`,
            );
        }
        return a > b;
    }

    if ("lt" in exp) {
        const a = evaluateExpression(exp.lt[0]);
        const b = evaluateExpression(exp.lt[1]);
        if (a === null || b === null) {
            throw new Error(
                `ActionCondition "lt" got "null" values: ${a} ${b}`,
            );
        }
        return a < b;
    }

    if ("gte" in exp) {
        const a = evaluateExpression(exp.gte[0]);
        const b = evaluateExpression(exp.gte[1]);
        if (a === null || b === null) {
            throw new Error(
                `ActionCondition "gte" got "null" values: ${a} ${b}`,
            );
        }
        return a >= b;
    }

    if ("lte" in exp) {
        const a = evaluateExpression(exp.lte[0]);
        const b = evaluateExpression(exp.lte[1]);
        if (a === null || b === null) {
            throw new Error(
                `ActionCondition "lte" got "null" values: ${a} ${b}`,
            );
        }
        return a <= b;
    }

    if ("hasVisitedScene" in exp) {
        const ctx = expectGameContext();
        return ctx.gameState.visitedScenes.has(exp.hasVisitedScene);
    }

    expectNever(exp);
}
